import {
  capraIconCaretDown,
  capraIconCalendar,
  capraIconGear,
  capraIconCaretRight,
  capraIconCheck,
  capraIconChevronRight,
  capraIconClock,
  capraIconClose,
  capraIconDotIndicator,
  capraIconFieldBoolean,
  capraIconFieldCalcBoolean,
  capraIconFieldCalcDate,
  capraIconFieldCalcNumeric,
  capraIconFieldCalcString,
  capraIconFieldDate,
  capraIconFieldNumeric,
  capraIconFieldString,
  capraIconInfoOutline,
  capraIconPaginationFirst,
  capraIconPaginationLast,
  capraIconPaginationNext,
  capraIconPaginationPrevious,
  capraIconPencil,
  capraIconRelevantValues,
  capraIconSearch,
  capraIconWarning,
  capraIlloErrorDataset,
  capraIlloFunnelGray,
  capraIlloNoResultTable,
  completeIconSet,
  capraIconGranularityBack,
} from '@mode/capra';

/**
 * This file is an abstraction for icon bundles that need to be imported
 * for use with `<capra-icon>` in the product.
/**
 * Application Icons
 *
 * This bundle represents all icons that are included in the application context
 * (meaning this does not include the embeds).
 */
export const APP_ICONS = completeIconSet;

/**
 * Embed Icons
 *
 * Add any icons that need to be accessible in the embed here. Embed icons need to be
 * registered in both the `embed-report.module` and the `embed-report-builder.module` as
 * they act as two separate entrypoints. This bundle will help facilitate maintaining
 * the icons available between those two entry points, as we can assume they're always
 * the same.
 *
 * Note - We should only add icons to this bundle when they are necessary in the embed.
 *   The intention is to keep this bundle smaller than the general app bundle by only
 *   including icons that are specifically required in the embed.
 */
export const EMBED_ICONS = [
  capraIconCaretDown,
  capraIconCalendar,
  capraIconGear,
  capraIconCaretRight,
  capraIconCheck,
  capraIconChevronRight,
  capraIconClock,
  capraIconClose,
  capraIconDotIndicator,
  capraIconFieldBoolean,
  capraIconFieldCalcBoolean,
  capraIconFieldCalcDate,
  capraIconFieldCalcNumeric,
  capraIconFieldCalcString,
  capraIconFieldDate,
  capraIconFieldNumeric,
  capraIconFieldString,
  capraIconGranularityBack,
  capraIconInfoOutline,
  capraIconPaginationFirst,
  capraIconPaginationLast,
  capraIconPaginationNext,
  capraIconPaginationPrevious,
  capraIconPencil,
  capraIconRelevantValues,
  capraIconSearch,
  capraIconWarning,
  capraIlloErrorDataset,
  capraIlloFunnelGray,
  capraIlloNoResultTable,
];
